import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, ref } from 'vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useEditor from '@/composables/useEditor'
  import Dropdown from '@/components/common/Dropdown.vue'
  import { UserModule } from '@/store/modules/user'
  import { useRoute, useRouter } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminNav',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const { isSachkundeCompany, isDrKleinCompany } = useCommonMixin()
  const { inEditorMode } = useEditor(route)
  const { translateString } = useI18n()
  const selectedDashboardView = ref('')

  const navOptions = [
    { name: translateString('navigation.admin.followups'), path: '/admin/followups' },
    { name: translateString('navigation.admin.gamification'), path: '/admin/gamification' },
    // { name: translateString('navigation.admin.theme'), path: '/admin/theme' },
    { name: translateString('navigation.admin.usersAndGroups'), path: '/admin/users-and-groups' },
  ]

  const dashboardViewItems = computed(() => {
    const items = [
      {
        type: 'editor',
        title: translateString('trainings.seeDashboardAs', { view: 'Editor' }),
        selectable: true,
      },
    ]
    if (UserModule.userGroups) {
      UserModule.userGroups.forEach((g) => {
        items.push({
          type: g.name,
          title: translateString('trainings.seeDashboardAs', { view: g.name }),
          selectable: true,
        })
      })
    }
    return items
  })

  const setDashboardViewQueryParam = (view: string) => {
    if (route.query.viewAs !== view) {
      selectedDashboardView.value = view
      router.replace({ path: route.path, query: { ...route.query, viewAs: view } })
    }
  }

  if (isSachkundeCompany.value || isDrKleinCompany.value) {
    navOptions.push({
      name: translateString('navigation.admin.analytics'),
      path: '/admin/analytics',
    })
  }

  watch(inEditorMode, (value) => {
    if (value && route.name === 'Trainings') {
      selectedDashboardView.value = 'editor'
      setDashboardViewQueryParam('editor')
    } else if (route.name === 'Trainings') {
      router.replace('/trainings').catch(() => {
        return
      })
    }
  })

return { __sfc: true,route, router, isSachkundeCompany, isDrKleinCompany, inEditorMode, translateString, selectedDashboardView, navOptions, dashboardViewItems, setDashboardViewQueryParam, computed, watch, ref, useCommonMixin, useEditor, Dropdown, UserModule, useRoute, useRouter, useI18n }
}

})